module.exports = __webpack_public_path__ + "img/compartilhar.f76c0766.svg";